import { TTheme } from '@types'

export const earnNFTNetworkTheme: TTheme = {
    theme: 'earn-nft-network',
    variables: {
        colorPrimary: '#00D632',
        colorBackground: '#232323',
        colorText: '#FFFFFF',
        colorGray: {
            primary: '#ddd',
            secondary: '#424242',
        },
        colorDanger: {
            primary: '#F90215',
            secondary: '#FFECED',
        },
        colorWarning: {
            primary: '#F6851B',
            secondary: '#39240F',
        },
        fontFamily: {
            headline: 'Work Sans, system-ui, sans-serif',
            title: 'Work Sans, system-ui, sans-serif',
            description: 'Work Sans, system-ui, sans-serif',
            text: 'Work Sans, system-ui, sans-serif',
        },
        badgeColor: {
            primary: '#00bcd4',
            secondary: '#ff9800',
            success: '#4caf50',
            warning: '#ff9800',
            danger: '#f44336',
            info: '#2196f3',
            light: '#f4f4f4',
            dark: '#212121',
        },
        borderRadius: '50px',
        boxShadow: '3px 6px 0px #110000',
        lineBorder: '#DCDCDC',
    },
}
